import type {PermissionMatrix} from '../types';
import {PERMISSION_MATRIX_NAMES, PermissionMatrixName} from '../constants';

export {PermissionMatrixName} from '../constants';
export type {PermissionMatrix} from '../types';

export const allows = (
	permissionMatrix: PermissionMatrix,
	perm?: PermissionMatrixName | null,
) => {
	if (perm == null) return false;
	const matrixIndex = PERMISSION_MATRIX_NAMES.indexOf(perm);
	return permissionMatrix[matrixIndex] === 1;
};

export default allows;
